/**
 * @fileoverview Workspace Pre-Appointment pipeline (MOR-882)
 *
 * URL: /dashboard/pre-appointment
 *
 * Cross-job pipeline-management surface for every pre-appointment job in
 * the active organisation: table + kanban views over firm-defined pipeline
 * stages and labels, saveable personal views, referrer tagging, firm-wide
 * conflict checks, and one-click DIRRI drafting. Renders the shared
 * `PipelineSurface`, which owns its own data subscriptions.
 */

import { createFileRoute } from "@tanstack/react-router";

import type { Id } from "@cvx/_generated/dataModel";

import { useActiveOrg } from "@/utils/org-context";
import { PipelineSurface } from "@/components/pre-appointment/PipelineSurface";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/pre-appointment",
)({
  component: PreAppointmentPage,
});

function PreAppointmentPage() {
  const { activeOrg } = useActiveOrg();
  const orgId = activeOrg?._id as Id<"organizations"> | undefined;

  if (!activeOrg || !orgId) {
    return (
      <div className="flex h-64 items-center justify-center text-sm text-muted-foreground">
        Select an organisation to view the pre-appointment pipeline.
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Pipeline Tracker
        </h1>
        <p className="text-sm text-muted-foreground">
          Manage your pre-appointment pipeline - track your referrals and
          enquiries and run conflict checks.
        </p>
      </div>

      <PipelineSurface
        orgId={orgId}
        canEdit={activeOrg.role === "owner" || activeOrg.role === "admin"}
      />
    </div>
  );
}
